import { Table, TableBody, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { TableCard } from "@/components/ui/table-card";
import { Checkbox } from "@/components/ui/checkbox";
import { EventRow } from "./EventRow";
import type { EventResponse, Category } from "@/types";

interface EventTableProps {
  events: EventResponse[];
  categories: Category[];
  selected: Set<string>;
  onToggleAll: () => void;
  onToggleOne: (id: string) => void;
}

export function EventTable({
  events,
  categories,
  selected,
  onToggleAll,
  onToggleOne,
}: EventTableProps) {
  const allSelected = events.length > 0 && selected.size === events.length;

  return (
    <TableCard>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-10">
              <Checkbox checked={allSelected} onCheckedChange={onToggleAll} />
            </TableHead>
            <TableHead className="w-[70px]"></TableHead>
            <TableHead>Tytuł</TableHead>
            <TableHead>Data</TableHead>
            <TableHead>Lokalizacja</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Kategoria</TableHead>
            <TableHead className="w-20">Akcje</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {events.map((event) => (
            <EventRow
              key={event.id}
              event={event}
              categories={categories}
              selected={selected.has(event.id)}
              onToggle={() => onToggleOne(event.id)}
            />
          ))}
        </TableBody>
      </Table>
    </TableCard>
  );
}
